const defaultState = {
  foundPosts: {
    data: [],
    pagingToken: 0,
    hasMore: true,
  },
  searchQuery: null,
};

const Search = (state = defaultState, action) => {
  switch (action.type) {
    case "SEARCH_POSTS_SUCCESS":
      const hasMore = !(action.posts.length < action.limit);
      const posts = action.override ? action.posts : [...state.foundPosts.data, ...action.posts];
      return {
        ...state,
        foundPosts: {
          data: posts,
          hasMore,
          pagingToken: action.pagingToken,
        },
        searchQuery: action.searchQuery,
      };

    case "CLEAR_SEARCH_POSTS":
      return defaultState;

    case "LIKE_POST_OPTIMISTIC":
      return setPostLike(state, action, true);

    case "UNLIKE_POST_OPTIMISTIC":
      return setPostLike(state, action, false);

    default:
      return state;
  }
};

function setPostLike(state, action, isLiked) {
  const numberChange = isLiked ? 1 : -1;
  return {
    ...state,
    foundPosts: {
      ...state.foundPosts,
      data: state.foundPosts.data.map(post => {
        if (post._id === action.postId) {
          if (!post.interactions) {
            post.interactions = { likesCount: 0 };
          }
          return {
            ...post,
            isLiked,
            interactions: {
              ...post.interactions,
              likesCount: post.interactions.likesCount + numberChange,
            },
          };
        }
        return post;
      }),
    },
  };
}

export default Search;



// WEBPACK FOOTER //
// ./src/reducers/Search/index.js